module.exports = __webpack_public_path__ + "static/img/home_new13.c278ead8.jpg";